import { InputsHeader } from '../InputsHeader';
import { Radio } from '../form-controls';
import { Grid } from '../layout';

export function Type() {
  const name = 'starterFertilizer.type';

  return (
    <>
      <InputsHeader
        title="Rx Type"
        subtitle="Select Rx Type Used"
        name={name}
        required
      />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }}>
        <Radio label="Variable" name={name} value="variable" />
        <Radio label="Flat" name={name} value="flat" />
      </Grid>
    </>
  );
}
